import { useEffect, useState } from "react";
import { api } from "./api";
import { setNewDays, setSeverityLabels } from "./theme";
import { setCareStyles } from "./careStyles";

export const SITE_DEFAULTS = { site_name: "The Green House on E Ave", tagline: "Plant Health Record", greeting: "", accent: "", new_days: 30, show_today: true, show_highlights: true, show_quick_actions: true, show_weather: true, show_new_arrivals: true, temp_unit: "f", wind_unit: "mph", hidden_sections: [], care_styles: {}, scene_theme: "auto", scene_holidays: true };

let cache = null;
const subs = new Set();
const apply = (s) => {
  setNewDays(s.new_days);
  setSeverityLabels(s.severity_labels);
  setCareStyles(s.care_styles);
  document.title = s.site_name;
  const root = document.documentElement.style;
  const m = /^#?([0-9a-f]{6})$/i.exec(s.accent || "");
  if (!m) { root.removeProperty("--primary"); root.removeProperty("--ring"); return; }
  const [r, g, b] = [0, 2, 4].map((i) => parseInt(m[1].slice(i, i + 2), 16) / 255);
  const max = Math.max(r, g, b), min = Math.min(r, g, b), l = (max + min) / 2, d = max - min;
  const sat = d ? d / (1 - Math.abs(2 * l - 1)) : 0;
  const h = !d ? 0 : max === r ? ((g - b) / d) % 6 : max === g ? (b - r) / d + 2 : (r - g) / d + 4;
  const hsl = `${Math.round(((h * 60) + 360) % 360)} ${Math.round(sat * 100)}% ${Math.round(l * 100)}%`;
  root.setProperty("--primary", hsl); root.setProperty("--ring", hsl);
};
const set = (s) => { cache = { ...SITE_DEFAULTS, ...s }; apply(cache); subs.forEach((f) => f(cache)); };

export const loadSite = () => api.get("/site").then((r) => set(r.data)).catch(() => set({}));
export const saveSite = async (s) => { const { data } = await api.put("/site", { settings: s }); set(data); return cache; };

export function useSite() {
  const [s, setS] = useState(cache || SITE_DEFAULTS);
  useEffect(() => { subs.add(setS); if (!cache) loadSite(); return () => subs.delete(setS); }, []);
  return s;
}
